// @flow
import * as React from 'react'
import OptionItem from '../OptionItem'
import { Container } from './elements'

// Types
export type Props = {
  maxHeight?: string,
  focusedIndex?: number,
  onOptionClick: Function,
  renderOption: Function,
  OptionWrapper?: any,
  options: Array<any>,
  optionSize?: any,
}

/**
 * Naive options list renderer that just renders a whole list
 * of options. Could be slow for large lists.
 * @return {React.Element}
 */
const NaiveListRenderer = ({
  maxHeight,
  focusedIndex,
  onOptionClick,
  renderOption,
  OptionWrapper,
  options,
}: Props) => (
  <Container $maxHeight={maxHeight}>
    {options.map((o, i) => (
      <OptionItem
        key={i}
        index={i}
        value={o}
        focused={focusedIndex === i}
        onClick={onOptionClick}
        renderOption={renderOption}
        OptionWrapper={OptionWrapper}
      />
    ))}
  </Container>
)

export default NaiveListRenderer
